import { doc, getDoc } from 'firebase/firestore';
import { resolveAccountBasePath } from './accountPaths';

const cache = new Map();

function keyOf(company, email, moduleId) {
  return `${(company || '').toLowerCase()}|${(email || '').toLowerCase()}|${moduleId || ''}`;
}

export async function getUserSubmodulesCached(db, companySlug, email, moduleId, options = {}) {
  const forceRefresh = options.forceRefresh === true;
  const slug = (companySlug || '').toString().trim().toLowerCase();
  const mail = (email || '').toString().trim().toLowerCase();
  const mod = (moduleId || '').toString().trim();
  if (!slug || !mail || !mod) return [];

  const cacheKey = keyOf(slug, mail, mod);
  if (!forceRefresh && cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  let submodules = [];

  const accountBasePath = resolveAccountBasePath(slug);
  const cfgRef = doc(db, `${accountBasePath}/users/${mail}/modules/config`);
  const cfgSnap = await getDoc(cfgRef);
  if (cfgSnap.exists()) {
    const cfg = cfgSnap.data() || {};
    const moduleCfg = cfg[mod] || {};
    if (moduleCfg && moduleCfg.enabled === true) {
      if (Array.isArray(moduleCfg.submodules)) submodules = moduleCfg.submodules.filter(Boolean);
      else if (typeof moduleCfg.submodules === 'string') submodules = [moduleCfg.submodules].filter(Boolean);
    }
  } else {
    const moduleRef = doc(db, `${accountBasePath}/users/${mail}/modules/${mod}`);
    const moduleSnap = await getDoc(moduleRef);
    if (moduleSnap.exists()) {
      const moduleData = moduleSnap.data() || {};
      const raw = moduleData.submodulos || moduleData.submodules || [];
      if (Array.isArray(raw)) submodules = raw.filter(Boolean);
      else if (typeof raw === 'string') submodules = [raw].filter(Boolean);
    }
  }

  cache.set(cacheKey, submodules);
  return submodules;
}
